<template>
  <el-dialog :title="title" width="550px" append-to-body destroy-on-close :modal="true" center :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="$emit('input',false)">
    <el-form ref="clueForm" :model="form" :rules="rules" label-width="80px" label-position="top" style="padding: 0 16px;">
      <el-row style="margin-bottom: 10px;" :gutter="20">
        <el-col :span="24">
          <el-form-item required prop="content" :label="contentItem.label">
            <el-input type="textarea" class="form-select" v-model.trim="form.content" :placeholder="'请填写'+contentItem.label"  show-word-limit :autosize="{ minRows: 4, maxRows: 6 }" :maxlength="300"/>
          </el-form-item>
        </el-col>
      </el-row>



      <el-form-item style="display: flex;justify-content: end;">
        <el-button :loading="loading" type="primary" @click="onSubmit('clueForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import CustomCardTable from "@/component/PrePayManage/dialog/CustomCardTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import {
  addClient,
  addClue,
  addClueInfoContent,
  exportExcel,
  exportPerformanceDetail,
  exportProjectDetail,
  getClueOption
} from "@/api/api";
import {quotation_type} from "@/config";
export default {
  name: "addClientDialog",
  components:{
  },
  props:{
    value:{
      type: Boolean,
      default:false,
      required: true
    },
    title:{
      type:String
    },
    contentItem:{
      type:Object
    }
  },
  data() {
    return {
      loading:false,
      dialogFormVisible: false,
      refreshId:0,
      form:{
        content:""
      },
      rules: {
        // this_progress: [
        //     {required: true, validator: validateThisProgress}
        // ],
        content: [
          {required: true, message: `请填写${this.contentItem.label}`}
        ]
      }
    }
  },

  watch:{
    value(newVal){
      this.dialogFormVisible = newVal
      if(this.dialogFormVisible){
        this.refresh()
      }
    },
    client_name(newVal){
      this.form.client_name = newVal
    },
    clueForm(newVal){
      Object.assign(this.form,newVal)
    }
  },
  mounted() {
    Object.assign(this.form,this.clueForm)
    this.form.client_name = this.client_name

    // this.quotation_type = quotation_type
    // this.getClientNameList()
  },
  methods:{
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('submit!',this.form);
          this.addContentAction()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    async addContentAction(){
      this.loading = true
      let postData = {
        index:this.contentItem.key,
        content:this.form.content,
        clue_id:this.contentItem.clue_id
      }
      console.log('addClueInfoContent',postData)
      let res = await addClueInfoContent(postData)
      if(res.respCode&&res.respCode=='000000'){
        console.log('addClueInfoContent',res)
        this.$message.success(res.respMsg)
        this.$emit("updateClientNameList")
        this.$nextTick(()=>{
          this.$emit('input',false)
          this.loading = false
          this.form.content = ""
        })
      }else{
        this.$message.error(res.respMsg)
      }
    },

    refresh(content){
      this.refreshId +=1
    }
  }
}
</script>

<style scoped>

/deep/ .form-select.el-select{
  width: 100%;
}

/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  /*height:600px;*/
  max-height:calc(100% - 200px);
  max-width:calc(100% - 30px);
}
/deep/ .el-dialog .el-dialog__body {
  flex:1;
  overflow: auto;
}

</style>
